import mainMixin from "./mainMixin";
import {provider} from "../service/provider";
import axios from "axios";

export default {
    name: "ReportDataMixin",
    mixins: [mainMixin],
    data() {
        return {
            categoryListOptRep: [],
            transactionListOptRep: [],
            transactionOptRep: [],
            clientListOptRep: [],
            clientListByLocationOptRep: [],
            productListOptRep: [],
            productTypeOptRep: [],
            contact_id:""
        };
    },
    methods: {
        fetchCategoryOptionRep(token) {
            let vm = this;
            let url = provider.baseURL + provider.fetchListCategoryOpt;
            return new Promise((resolve, reject) => {
                axios.post(url, {}, {headers: {Authorization: localStorage.token || token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.categoryListOptRep = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });

        },
        fetchListCustomerTypeOpt(token) {
            let vm = this;
            let url = provider.baseURL + provider.fetchCustomerTypeOpt;
            return new Promise((resolve, reject) => {
                axios.post(url, {}, {headers: {Authorization: localStorage.token || token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.transactionListOptRep = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },
        fetchListProductTypeOpt(token) {
            let vm = this;
            let url = provider.baseURL + provider.fetchProductTypeOpt;
            return new Promise((resolve, reject) => {
                axios.post(url, {}, {headers: {Authorization: localStorage.token || token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.productTypeOptRep = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },
        fetchCustomerTypesOpt(token) {
            let vm = this;
            let url = provider.baseURL + provider.fetchTransactionTypeOpt;
            return new Promise((resolve, reject) => {
                axios.post(url, {}, {headers: {Authorization: localStorage.token || token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.transactionOptRep = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },
        fetchContactOptionRep(token) {
            let vm = this;
            let url = provider.baseURL + provider.fetchListContactOpt;
            return new Promise((resolve, reject) => {
                axios.post(url, {user_type: localStorage.type || ""}, {headers: {Authorization: token }}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.clientListOptRep = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });

        },
        fetchContactIdByToken(token) {
            let vm = this;
            let url = provider.baseURL + provider.getContactByToken;
            return new Promise((resolve, reject) => {
                axios.post(url, {}, {headers: {Authorization:token }}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            if(res.data.data.contact_id){
                                res.data.data.contact_id.username=vm.my_encrypt(res.data.data.contact_id.username);
                                localStorage.setItem('token', res.data.data.contact_id.token);
                                localStorage.setItem('username', res.data.data.contact_id.username);
                                localStorage.setItem('contact_id', res.data.data.contact_id.contact_id);
                                localStorage.setItem('type', res.data.data.contact_id.type);
                                localStorage.setItem('position', res.data.data.contact_id.position);
                                localStorage.setItem('profile', res.data.data.contact_id.profile);
                                localStorage.setItem('parent_id', res.data.data.contact_id.parent_id);
                                localStorage.setItem('full_name', res.data.data.contact_id.full_name);
                                localStorage.setItem('province_code', res.data.data.contact_id.province_code || "");
                                localStorage.setItem('id', res.data.data.contact_id.id);
                                localStorage.setItem('phone', vm.formatPhoneNumber(res.data.data.contact_id.phone));
                                vm.$store.state.userDoc = res.data.data.contact_id;
                            }

                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });

        },
        fetchContactByLocationOptionRep(search, member_type) {
            let vm = this;
            let url = provider.baseURL + provider.getListClientByLocation;
            let selector = {};
            selector.search = search || "";
            selector.member_type = member_type || "";
            return new Promise((resolve, reject) => {
                axios.post(url, selector, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.clientListByLocationOptRep = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });

        },
        fetchProductOptionByCategoryIdRep() {
            let vm = this;
            let url = provider.baseURL + provider.fetchListContactOpt;
            return new Promise((resolve, reject) => {
                axios.post(url, {user_type: localStorage.type}, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.clientListOptRep = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });

        },
    }
};
